import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  id: '',
  logged_in: false,
  header : false,
}

// getters
const getters = {
  userId: state => state.id,
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.STORE_FETCHED_USER] (state, { uid }) {
    state.id = uid
  },

  [types.LOGIN_USER] (state) {
    state.logged_in = true
  },

  setHeaderWhite(state, data){
    state.header = data
  },

  [types.LOGOUT_USER] (state) {
    state.logged_in = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js